import { render, staticRenderFns } from "./project_admin.vue?vue&type=template&id=5ea4d40e&scoped=true&"
import script from "./project_admin.vue?vue&type=script&lang=ts&"
export * from "./project_admin.vue?vue&type=script&lang=ts&"
import style0 from "./project_admin.vue?vue&type=style&index=0&id=5ea4d40e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4d40e",
  null
  
)

export default component.exports